module.exports = __webpack_public_path__ + "static/media/facebook.92f23286.92f23286.svg";